import { ClipboardCheck } from 'lucide-react'

import InventoryBreadcrumb from './components/InventoryBreadcrumb'

import { columns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import { LogisticInventoryProvider } from './hooks/useLogisticInventory'
import { ProductDetailsProvider } from './contexts/ProductDetailsContext'

export default function InventoryList() {
  return (
    <LogisticInventoryProvider>
      <ProductDetailsProvider>
        {/* Contenedor principal que usa toda la altura del viewport */}
        {/* eslint-disable-next-line max-len */}
        <div className="inventory-main-container w-full min-w-0 font-[Geist] [&_*]:font-[Geist] [&_.font-mono]:font-[GeistMono] [&_code]:font-[GeistMono] [&_pre]:font-[GeistMono]">
          <InventoryBreadcrumb
            icon={<ClipboardCheck className="h-5 w-5 text-gray-500" />}
            paths={[{ name: 'Logística (Beta)' }, { name: 'Inventario' }]}
          />
          <div className="inventory-table-wrapper">
            <TableContextProvider>
              <DataTable columns={columns} />
            </TableContextProvider>
          </div>
        </div>
      </ProductDetailsProvider>
    </LogisticInventoryProvider>
  )
}
